/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetClassResponse } from './GetClassResponse';
import {
    GetClassResponseFromJSON,
    GetClassResponseFromJSONTyped,
    GetClassResponseToJSON,
    GetClassResponseToJSONTyped,
} from './GetClassResponse';

/**
 * 
 * @export
 * @interface GetBulkClassesResponse
 */
export interface GetBulkClassesResponse {
    /**
     * 
     * @type {Array<GetClassResponse>}
     * @memberof GetBulkClassesResponse
     */
    items: Array<GetClassResponse>;
}

/**
 * Check if a given object implements the GetBulkClassesResponse interface.
 */
export function instanceOfGetBulkClassesResponse(value: object): value is GetBulkClassesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetBulkClassesResponseFromJSON(json: any): GetBulkClassesResponse {
    return GetBulkClassesResponseFromJSONTyped(json, false);
}

export function GetBulkClassesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBulkClassesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetClassResponseFromJSON)),
    };
}

export function GetBulkClassesResponseToJSON(json: any): GetBulkClassesResponse {
    return GetBulkClassesResponseToJSONTyped(json, false);
}

export function GetBulkClassesResponseToJSONTyped(value?: GetBulkClassesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetClassResponseToJSON)),
    };
}

